import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import MainLayout from "../../../layouts/main_layout/main_layout";

interface Props {}

function PromptAndPaint(props: Props) {
  const {} = props;

  return (
    <MainLayout>
      <Box my={4}>
        <Box display={"flex"} justifyContent="center" mb={4}>
          <Typography variant="h4" alignItems={"center"}>
            Prompt And Paint
          </Typography>
        </Box>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <img
              src="/images/dabazo/promptAndPaint.jpg"
              alt="Prompt and Paint"
              style={{
                width: "100%",
                height: "auto",
                opacity: 1,
                transition: "opacity 1s ease-in-out",
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </MainLayout>
  );
}

export default PromptAndPaint;
